import { escapeHTML } from "../../render/ui-helpers.js";

export function renderHarnessThreadCreateFields(state, pageState) {
  return `
    <div class="form-note">This thread will use the harness runtime and a workspace.</div>
    ${state.workspaces.length === 0 ? `<div class="form-note form-note--warn">Register a workspace first for harness-backed threads. <a class="button button--sm button--primary" href="/workspaces" data-route style="margin-left:var(--space-sm)">Workspaces</a></div>` : ""}
    <select id="thread-workspace-id" name="workspace_id" required ${state.workspaces.length === 0 ? "disabled" : ""}>
      <option value="">Workspace</option>
      ${state.workspaces.map((item) => `<option value="${escapeHTML(item.id)}" ${pageState.threadDraft.workspace_id === item.id ? "selected" : ""}>${escapeHTML(item.name)}</option>`).join("")}
    </select>
    <input id="thread-base-ref" name="base_ref" placeholder="Base branch (main)" value="${escapeHTML(pageState.threadDraft.base_ref)}" ${state.workspaces.length === 0 ? "disabled" : ""}>
  `;
}
